/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import type EmailResponsesSettings from 'embercom/models/ai-agent/email-responses-settings';

export default class FinAIAgentSettingsIndexController extends Controller {
  queryParams = ['section'];
  declare section?: string;

  declare model: {
    aiAgentQuickReplySettings: any;
    aiAgentSettings: any;
    aiAgentToneOfVoiceSettings: any;
    aiAgentMultilingualSettings: any;
    aiAgentEmailResponsesSettings: EmailResponsesSettings;
    previewConfiguration: any;
    languages: any;
  };
}
